const employerQuery = (id) => {
    return `
    query {
      deleteEmployer(id: "${id}")
    }
    `
}

export default employerQuery